import { Language } from "../languages/labels/language.labels"

export function exportTypeList(): {code: string, display: string}[] {
  return [
    { code: 'excel', display: 'Excel (.xlsx)' },
    { code: 'pdf', display: 'PDF (.pdf)' }
  ]
}

export function exportTypeValue(lang: Language, code: string): string {
  let exportType = exportTypeList().find((item) => (item.code === code))
  return exportType ? exportType.display : lang.labels.undefined
}
